import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SessionContext } from 'src/providers/session/SessionContext.tsx';
import { EnvironmentContext } from 'src/providers/environment/EnvironmentContext.tsx';

export default function LoadingPage() {
  const navigate = useNavigate();

  const sessionContext = React.useContext(SessionContext);
  const environmentContext = React.useContext(EnvironmentContext);

  useEffect(() => {
    const envSub = environmentContext.watchEnvironment().subscribe((env) => {
      if (!env.loaded) return;

      const homePage = env.homePage || '/';
      const originalPath = sessionContext.getOriginalPath();
      const hasSession = sessionContext.isJwt();

      if (!hasSession) {
        navigate('/login');
        return;
      }

      const invalidOriginalPaths = ['/', '/login', '/login/', '/loading', '/loading/'];

      if (originalPath && !invalidOriginalPaths.includes(originalPath)) {
        navigate(originalPath);
      } else {
        navigate('/' + homePage);
      }
    });

    return () => envSub.unsubscribe();
  }, []);

  return (
    <div
      className="text-center"
      style={{ marginTop: 120 }}
    >
      <h2 style={{ opacity: 0.75 }}>Loading…</h2>
    </div>
  );
}
